import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  getAllPlanList,
  createPlan,
  updatePlan,
  deletePlan
} from '../../modules/plan'

import {
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Tag
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'
import PlanForm from './components/PlanForm'

const Plans = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')

  const { planList, isLoading } = useSelector(
    (state) => ({
      planList: state.plan.planList,
      isLoading: state.plan.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getAllPlanList())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => {
    await dispatch(getAllPlanList())
  }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(getAllPlanList())
    await setVisible(false)
    setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deletePlan(id))
    await dispatch(getAllPlanList())
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updatePlan(data))
    } else {
      await dispatch(createPlan(data))
    }

    await dispatch(getAllPlanList())
    setVisible(false)
    setFormData({})
  }

  const columns = [
    {
      title: 'Plan',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'รายการชั่ง',
      dataIndex: 'limitWeighing',
      key: 'limitWeighing',
      width: 115,
      render: (limitWeighing) => {
        return limitWeighing != 0 ? limitWeighing : <span>ไม่จำกัด</span>
      }
    },
    {
      title: 'รายการบัญชี',
      dataIndex: 'limitAccounting',
      key: 'limitAccounting',
      width: 115,
      render: (limitAccounting) => {
        return limitAccounting != 0 ? limitAccounting : <span>ไม่จำกัด</span>
      }
    },
    {
      title: 'ลายน้ำ',
      dataIndex: 'watermark',
      key: 'watermark',
      width: 115,
      render: (alertSetting) => {
        return alertSetting ? <span>มี</span> : <span>ไม่มี</span>
      }
    },
    {
      title: 'เวลาเก็บรูป(วัน)',
      dataIndex: 'saveImageLongTime',
      key: 'saveImageLongTime',
      width: 115
    },
    {
      title: 'ส่งอีเมลรายงาน',
      dataIndex: 'sentEmailReport',
      key: 'sentEmailReport',
      width: 115,
      render: (alertSetting) => {
        return alertSetting ? <span>มี</span> : <span>ไม่มี</span>
      }
    },
    {
      title: 'ศูนย์การแจ้ง',
      dataIndex: 'alertSetting',
      key: 'alertSetting',
      width: 115,
      render: (alertSetting) => {
        return alertSetting ? <span>มี</span> : <span>ไม่มี</span>
      }
    },
    {
      title: 'ระยะเวลา(วัน)',
      dataIndex: 'time',
      key: 'time',
      width: 115
    },
    {
      title: 'ราคาเต็ม',
      dataIndex: 'price',
      key: 'price',
      width: 100
    },
    {
      title: 'สถานะ',
      dataIndex: 'isActive',
      key: 'isActive',
      width: 100,
      render: (isActive) => {
        return isActive ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="Plan List"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            เพิ่มแพ็กเกจ
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Table
        loading={isLoading}
        scroll={{ x: 1300 }}
        rowKey={(record) => record.id}
        dataSource={planList}
        columns={columns}
      />
      <PlanForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default compose(withApollo)(Plans)
